import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { JSX, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import { RootState } from "../../app/store";
import { useRefreshMutation } from "./authApiSlice";
import { selectCurrentToken } from "./authSlice";

// Define the structure of the error response
interface ErrorResponse {
  data?: {
    message?: string;
  };
}

const PersistLogin = () => {
  const token = useSelector((state: RootState) => selectCurrentToken(state));

  const effectRan = useRef(false);

  const [trueSuccess, setTrueSuccess] = useState(false);

  const [refresh, { isUninitialized, isLoading, isSuccess, isError, error }] =
    useRefreshMutation();

  useEffect(() => {
    if (effectRan.current === true || process.env.NODE_ENV !== "development") {
      // React 18 Strict Mode

      const verifyRefreshToken = async () => {
        console.log("verifying refresh token");
        try {
          await refresh().unwrap();
          setTrueSuccess(true);
        } catch (err) {
          console.error(err);
        }
      };

      if (!token) verifyRefreshToken();
    }

    return () => {
      effectRan.current = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, token]);

  let content: JSX.Element | null = null; // Ensure `content` always has a valid type
  if (isLoading) {
    // persist: yes, token: no
    content = (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  } else if (isError) {
    // persist: yes, token: no
    const errorMessage =
      (error as FetchBaseQueryError & ErrorResponse)?.data?.message ??
      "Unknown error";
    content = (
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="flex p-3">
          <h1>Error Message:</h1> <p>{` - ${errorMessage}`}</p>
        </div>
        <p className="errmsg">
          <Link
            className="w-full text-center p-3 rounded bg-primary hover:bg-primary focus:outline-none my-1 text-white font-bold"
            to="/sign-in"
          >
            Please login again
          </Link>
        </p>
      </div>
    );
  } else if (isSuccess && trueSuccess) {
    console.log("Persist successful");
    // persist: yes, token: yes
    content = <Outlet />;
  } else if (token && isUninitialized) {
    // persist: yes, token: yes
    console.log(isUninitialized);
    content = <Outlet />;
  }

  return content; // Return `content`, which will be either JSX or `null`
};

export default PersistLogin;
